import { createForqRuntime } from '@forq/kernel';
import { adminFeatures, adminModule } from '@forq/admin';
import { auswertungFeatures, auswertungModule } from '@forq/auswertung';
import {
  completePreviewFeatures,
  completePreviewModule,
  previewModules,
} from '@forq/complete-preview';
import { customersFeatures, customersModule } from '@forq/customers';
import { dashboardFeatures, dashboardModule } from '@forq/dashboard';
import { importFeatures, importModule } from '@forq/import';
import { machinesFeatures, machinesModule } from '@forq/machines';
import { masterdataFeatures, masterdataModule } from '@forq/masterdata';
import { ordersFeatures, ordersModule } from '@forq/orders';
import { partsFeatures, partsModule } from '@forq/parts';
import { salesFeatures, salesModule } from '@forq/sales';
import { serviceFeatures, serviceModule } from '@forq/service';
import { warehouseFeatures, warehouseModule } from '@forq/warehouse';

export const runtime = createForqRuntime();
runtime.modules.register(dashboardModule);
runtime.features.registerMany(dashboardFeatures);
runtime.modules.register(auswertungModule);
runtime.features.registerMany(auswertungFeatures);
runtime.modules.register(customersModule);
runtime.features.registerMany(customersFeatures);
runtime.modules.register(machinesModule);
runtime.features.registerMany(machinesFeatures);
runtime.modules.register(masterdataModule);
runtime.features.registerMany(masterdataFeatures);
runtime.modules.register(ordersModule);
runtime.features.registerMany(ordersFeatures);
runtime.modules.register(serviceModule);
runtime.features.registerMany(serviceFeatures);
runtime.modules.register(partsModule);
runtime.features.registerMany(partsFeatures);
runtime.modules.register(warehouseModule);
runtime.features.registerMany(warehouseFeatures);
runtime.modules.register(salesModule);
runtime.features.registerMany(salesFeatures);
// Diese Vorschaumodule bleiben im Katalog (/complete-preview) als geplante Arbeitsbereiche sichtbar,
// werden aber NICHT in die Navigation registriert. Zum Reaktivieren: id hier + in App.tsx entfernen.
//   orders/service   -- durch die echten Module ersetzt
//   logistics        -- Spedition, vorerst zurückgestellt
//   technician       -- Monteurbereich, zurückgestellt
//   purchasing       -- „Einkauf" hat KEINE Datenanbindung (erfundene Kennzahlen). Solange kein
//                       Einkaufsmodul gebaut ist, darf es nicht wie ein Betriebsbereich im Menü stehen.
const nichtInDieNavigation = ['orders', 'service', 'logistics', 'technician', 'purchasing'];
runtime.modules.registerMany(previewModules.filter((module) => !nichtInDieNavigation.includes(module.id)));
runtime.modules.register(completePreviewModule);
runtime.features.registerMany(completePreviewFeatures);
runtime.modules.register(adminModule);
runtime.features.registerMany(adminFeatures);
runtime.modules.register(importModule);
runtime.features.registerMany(importFeatures);
